<template>
  <div class="report-cont">
    <div
      v-show="!Object.keys(latest).length && !reports.length"
      class="ongoing-cont"
    >
      <img class="ongoing-img" src="@/assets/images/ongoing_img.png">
      <span class="span-txt">暂无报告</span>
    </div>
    <div v-show="Object.keys(latest).length" class="report-data">
      <div class="header-cont">
        <h3 class="title-txt">最新报告</h3>
      </div>
      <div class="report-list">
        <div class="report-li">
          <div class="li-header">
            <div class="line">
              <span>手机尾号：</span>
              <p class="number-txt">{{ latest.clientPhoneTailNumber }}</p>
            </div>
            <div class="line">
              <span>测试门店：</span>
              <p>{{ (latest.address && latest.address.address) || "" }}</p>
            </div>
            <div class="line">
              <span>测试时间：</span>
              <p>{{ latest.createTime }}</p>
            </div>
          </div>
          <div class="li-body">
            <img class="qrcode-img" :src="latest.miniQr">
            <h3>扫描二维码进入UA HOUSE小程序</h3>
            <p>
              获取您的<span class="color-txt">专属体能评估报告</span>及<span
                class="color-txt"
              >个性化训练建议</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showHistory" class="report-data bg-color history">
      <div class="header-cont">
        <h3 class="title-txt">历史报告</h3>
        <div class="date-cont">
          <el-date-picker
            v-model="date"
            :editable="false"
            align="right"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            type="date"
            class="custom-date"
            placeholder="选择日期"
            @change="handleDateChange"
          />
          <i class="el-icon-arrow-down" />
        </div>
      </div>
      <div class="report-list">
        <template v-if="reports.length">
          <div v-for="item in reports" :key="item.id" class="report-li">
            <div class="li-header">
              <div class="line">
                <span>手机尾号：</span>
                <p class="number-txt">{{ item.clientPhoneTailNumber }}</p>
              </div>
              <div class="line">
                <span>测试门店：</span>
                <p>{{ (item.address && item.address.address) || "" }}</p>
              </div>
              <div class="line">
                <span>测试时间：</span>
                <p>{{ item.createTime }}</p>
              </div>
            </div>
            <div class="li-body">
              <img class="qrcode-img" :src="item.miniQr">
              <h3>扫描二维码进入UA HOUSE小程序</h3>
              <p>
                获取您的<span class="color-txt">专属体能评估报告</span>及<span
                  class="color-txt"
                >个性化训练建议</span>
              </p>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="empty-wrap">
            <img class="ongoing-img" src="@/assets/images/ongoing_img.png">
            <span class="span-txt">暂无报告</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Report",
  data() {
    return {
      date: new Date(),
      showHistory: false,
      latest: {}, // 最新报告
      reports: [],
      params: {
        assessmentDate: moment().format("YYYY-MM-DD"),
      },
    };
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.handleFetchLatest();
          this.handleFetchList();
        }
      },
      deep: true,
    },
  },
  async created() {
    this.handleFetchLatest();
    this.handleFetchList();
  },
  methods: {
    handleDateChange(val) {
      this.params = {
        ...this.params,
        assessmentDate: val,
      };
    },
    handleFetchLatest() {
      this.$Api.stores
        .findLatest()
        .then((res) => {
          this.latest = res;
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    handleFetchList() {
      this.$Api.stores
        .fetchQuestionList(this.params.assessmentDate)
        .then((res) => {
          this.reports = [];
          if (Array.isArray(res) && res.length) {
            this.reports = [...res];
          }
          this.showHistory = true;
        })
        .catch((err) => {
          this.showHistory = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.report-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ongoing-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .ongoing-img {
    width: calc(43px * 0.75);
  }
  .span-txt {
    margin: calc(18px * 0.75) auto calc(30px * 0.75);
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: normal;
    font-size: calc(18px * 0.75);
    line-height: calc(30px * 0.75);
    text-align: center;
    color: #494949;
  }
  .update-btn {
    width: calc(230px * 0.75);
    height: calc(64px * 0.75);
  }
}
.report-data {
  width: 100%;
  padding: calc(50px * 0.75) calc(102px * 0.75) 0 calc(102px * 0.75);
  &.bg-color {
    background: rgba(247, 247, 247, 1);
  }
  &.history {
    min-height: 590px;
  }
  .header-cont {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: calc(30px * 0.75);
  }
  .date-cont {
    display: flex;
    flex-direction: row;
    align-items: center;
    .el-icon-arrow-down {
      font-size: calc(18px * 0.75);
      &::before {
        color: #494949 !important;
      }
    }
  }
  .title-txt {
    width: 100%;
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: bold;
    font-size: calc(24px * 0.75);
    line-height: calc(35px * 0.75);
    color: #000000;
    text-align: left;
  }
  .report-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .empty-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: calc(590px - (30px * 0.75));
      .ongoing-img {
        width: calc(43px * 0.75);
      }
      .span-txt {
        margin: calc(18px * 0.75) auto calc(30px * 0.75);
        font-family: Noto Sans SC;
        font-style: normal;
        font-weight: normal;
        font-size: calc(18px * 0.75);
        line-height: calc(30px * 0.75);
        text-align: center;
        color: #494949;
      }
    }
    .report-li {
      width: calc(384px * 0.75);
      height: calc(408px * 0.75);
      // margin-right: calc(50px * 0.75);
      margin-bottom: calc(50px * 0.75);
      box-shadow: 0px 0px 10px rgba(227, 227, 229, 0.5);
      filter: drop-shadow(0px 0px 10px rgba(227, 227, 229, 0.5));
      background-color: #ffffff;
      // &:nth-child(2n) {
      //   margin-right: 0;
      // }
      .li-header {
        padding: calc(22px * 0.75) calc(30px * 0.75) calc(18px * 0.75)
          calc(30px * 0.75);
        background: #000000;
        .line {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          margin-bottom: calc(7px * 0.75);
          font-family: Noto Sans SC;
          font-style: normal;
          font-weight: 500;
          font-size: calc(14px * 0.75);
          line-height: calc(24px * 0.75);
          color: #f7f7f7;
          &:last-child {
            margin-bottom: 0;
          }
          p {
            flex: 1;
            &.number-txt {
              font-family: Neue Plak;
              font-style: normal;
              font-weight: bold;
              font-size: calc(28px * 0.75);
            }
          }
        }
      }
      .li-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: calc(17px * 0.75);
        .qrcode-img {
          width: calc(130px * 0.75);
          height: calc(130px * 0.75);
        }
        h3 {
          margin-top: calc(9px * 0.75);
          font-family: Noto Sans SC;
          font-style: normal;
          font-weight: bold;
          font-size: calc(18px * 0.75);
          line-height: calc(50px * 0.75);
          color: #000000;
        }
        p {
          font-family: Noto Sans SC;
          font-style: normal;
          font-weight: 500;
          font-size: calc(14px * 0.75);
          color: #000000;
          .color-txt {
            color: #dc0119;
          }
        }
      }
    }
  }
}
/deep/.custom-date {
  width: calc(150px * 0.75);
  .el-input__inner {
    width: calc(150px * 0.75);
    height: auto;
    line-height: inherit;
    padding: 0;
    border: 0;
    background-color: transparent;
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: normal;
    font-size: calc(18px * 0.75);
    color: #494949;
  }
  .el-input__prefix,
  .el-input__suffix {
    display: none;
  }
}
</style>
